import { Router } from '@angular/router';
import {Injectable} from '@angular/core';

import {AccessControlService} from "../service/access-control.service";

@Injectable()
export class RouteAccessGuard  {

  constructor(private accessControl: AccessControlService, private router: Router) {}

  canActivate(): boolean {
    if (this.accessControl.isAccessAllowed()) {
      return true;
    } else {
      this.router.navigate(['/home']);
      return false;
    }
  }
}
